import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 22.129 40.264'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M195.663,42.2a1.792,1.792,0,0,1-3.584,0V31.1c0-.907.139-2.305-1.209-2.305s-1.209,1.4-1.209,2.305V42.2a1.792,1.792,0,0,1-3.584,0V17.931a.715.715,0,0,0-1.43.019v9.575a1.663,1.663,0,0,1-3.326,0V18.687c0-3.521,1.575-6.74,5.512-6.74h1.493c.781,1.367,1.688,1.89,2.539,1.871.85.019,1.751-.5,2.539-1.871h1.493c3.937,0,5.512,3.219,5.512,6.74,0,2.677,1.323,4,2.677,6.343a1.661,1.661,0,0,1-.611,2.268l-.025.013a2.348,2.348,0,0,1,.227.2,2.593,2.593,0,0,1,.775,1.852V43.1a.882.882,0,0,1-1.764,0V29.364a.853.853,0,0,0-.252-.6.852.852,0,0,0-1.209,0,.868.868,0,0,0-.252.6.882.882,0,1,1-1.764,0,2.632,2.632,0,0,1,2.066-2.557l-.069-.113c-2.665-4.2-3.124-3.956-3.124-8.737a.715.715,0,0,0-1.43-.019V42.2ZM190.87,3.72a3.424,3.424,0,1,1-3.42,3.427,3.43,3.43,0,0,1,3.42-3.427Z'
      data-name='Path 4382'
      fill='#007e75'
      id='Path_4382'
      transform='translate(-181.32 -3.72)'
    />
  </svg>
);
